import React, { useEffect, useRef } from 'react';
import './ProductionPlanSuccessDialog.css';

const ProductionPlanSuccessDialog = ({ plan, onClose, onViewPlan }) => {
    const viewButtonRef = useRef(null);

    // Auto-focus primary button on mount
    useEffect(() => {
        if (viewButtonRef.current) {
            viewButtonRef.current.focus();
        }
    }, []);

    // Listen to Escape key press to dismiss
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    if (!plan) return null;

    const formatDate = (dateStr) => {
        if (!dateStr) return '—';
        try {
            const date = new Date(dateStr + 'T00:00:00');
            const day = date.getDate();
            const month = date.toLocaleString('default', { month: 'short' });
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        } catch (e) {
            return dateStr;
        }
    };

    return (
        <>
            {/* Backdrop Dark Overlay */}
            <div className="gsp-dialog-overlay" onClick={onClose} />

            {/* Success Dialog Modal Box */}
            <div className="gsp-dialog-box" onClick={(e) => e.stopPropagation()}>
                {/* Large Green Checkmark Circle Accent */}
                <div className="gsp-dialog-icon-circle">
                    <svg className="gsp-dialog-checkmark" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>

                <h2 className="gsp-dialog-title">Production Plan Created!</h2>
                <p className="gsp-dialog-desc">
                    Your production plan has been created successfully and is now ready for scheduling and execution.
                </p>

                {/* Details Table Card */}
                <div className="gsp-dialog-details-card">
                    <div className="gsp-dialog-detail-row">
                        <span className="gsp-dialog-detail-label">Production Plan</span>
                        <span className="gsp-dialog-detail-value">{plan.name}</span>
                    </div>
                    <div className="gsp-dialog-detail-row">
                        <span className="gsp-dialog-detail-label">Start Date</span>
                        <span className="gsp-dialog-detail-value">{formatDate(plan.startDate)}</span>
                    </div>
                    <div className="gsp-dialog-detail-row">
                        <span className="gsp-dialog-detail-label">End Date</span>
                        <span className="gsp-dialog-detail-value">{formatDate(plan.endDate)}</span>
                    </div>
                    <div className="gsp-dialog-detail-row">
                        <span className="gsp-dialog-detail-label">Products</span>
                        <span className="gsp-dialog-detail-value">
                            {plan.productsCount} {plan.productsCount === 1 ? 'Product' : 'Products'}
                        </span>
                    </div>
                </div>

                {/* Dialog Footer Actions */}
                <div className="gsp-dialog-actions">
                    <button
                        ref={viewButtonRef}
                        className="btn btn-primary gsp-dialog-view-btn"
                        onClick={onViewPlan}
                    >
                        View Production Plan
                    </button>
                    <button
                        className="btn btn-secondary gsp-dialog-done-btn"
                        onClick={onClose}
                    >
                        Done
                    </button>
                </div>
            </div>
        </>
    );
};

export default ProductionPlanSuccessDialog;
